/**
 * @file     brokerReferralDisclosure.ts
 * @purpose  The referral-fee disclosure every broker introduction quotes word
 *           for word, from the Referral compensation section on /disclosure
 *           (src/views/disclosure/index.tsx). A test keeps the two identical.
 */
export const BROKER_REFERRAL_DISCLOSURE =
  'Ray Rasouli may receive a referral fee from a mortgage broker Ray introduces you to if you choose to work with that broker and a mortgage transaction closes. This compensation does not affect the rate, product, or advice you receive from the broker, and it does not increase the costs you pay.';
